import { InnerBox } from "@/components/elements/InnerBox";
import { TalentFormEducationFields } from "@/features/talent/components/talent-form/TalentFormEducationFields";
import { TalentFormHeldQualificationsFields } from "@/features/talent/components/talent-form/TalentFormHeldQualificationsFields";
import { TalentFormLanguageSkillsFields } from "@/features/talent/components/talent-form/TalentFormLanguageSkillsFields";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Collapse } from "@mui/material";

type TalentFormEducationBackgroundProps = {};

export const TalentFormEducationBackground: FCC<TalentFormEducationBackgroundProps> = () => {
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <CollapsibleSectionHeader title="学歴・保有資格・語学" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
        <TalentFormEducationFields />
        <TalentFormHeldQualificationsFields />
        <TalentFormLanguageSkillsFields />
      </Collapse>
    </InnerBox>
  );
};
